// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge_badge__A0Ar2","hasNotification":"badge_hasNotification___w0mN"};